import api from "./api/api";

const ALERT_REPORT_SHARING_API = '/api/alert-report-sharing';

// Share an alert report
export const shareAlertReport = async (alertReportId, recipientIds, shareMessage = '', isUniversal = false, customAlertSlug = null, shareType = "FULL_ALERT_REPORT", activeFacilities = []) => {
    try {
        const requestBody = {
            alertReportId,
            recipientIds,
            shareMessage,
            isUniversal,
            shareType,
            activeFacilities
        };

        // Add custom alert specific fields if needed
        if (shareType === "CUSTOM_ALERT_ONLY" && customAlertSlug) {
            requestBody.customAlertSlug = customAlertSlug;
        }

        const response = await api.post(`${ALERT_REPORT_SHARING_API}/share`, requestBody);
        return response;
    } catch (error) {
        console.error('Error sharing alert report:', error);
        throw error;
    }
};

// Respond to share invitation
export const respondToAlertReportShare = async (shareId, response, newName = null) => {
    try {
        const result = await api.post(`${ALERT_REPORT_SHARING_API}/respond`, {
            shareId,
            response,
            newName
        });
        return result;
    } catch (error) {
        console.error('Error responding to alert report share:', error);
        throw error;
    }
};

// Get shared alert reports
export const getSharedAlertReports = async (page = null, includeOwned = false) => {
    try {
        const params = { includeOwned };
        if (page) {
            params.page = page;
        }
        
        const response = await api.get(`${ALERT_REPORT_SHARING_API}/shared`, {
            params
        });
        return response;
    } catch (error) {
        console.error('Error getting shared alert reports:', error);
        throw error;
    }
};

// Get existing shares for a specific alert report
export const getAlertReportShares = async (alertReportId, customAlertSlug = null, shareType = null) => {
    try {
        const params = {};
        if (customAlertSlug && shareType === "CUSTOM_ALERT_ONLY") {
            params.customAlertSlug = customAlertSlug;
            params.shareType = shareType;
        }

        const response = await api.get(`${ALERT_REPORT_SHARING_API}/${alertReportId}/shares`, { params });
        return response;
    } catch (error) {
        console.error('Error getting alert report shares:', error);
        throw error;
    }
};

// Toggle facility status for shared alert report
export const toggleSharedAlertReportFacility = async (shareId, facilityId, enabled) => {
    try {
        const response = await api.post(`${ALERT_REPORT_SHARING_API}/toggle-facility`, {
            shareId,
            facilityId,
            enabled
        });
        return response;
    } catch (error) {
        console.error('Error toggling shared alert report facility:', error);
        throw error;
    }
}; 